import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getProfile } from "../../environment";
import useApi from "../../core/customhook/useApi";
import Footer from "../../core/common/footer/Footer";
import SnipperLoader from "../../core/common/loader/SnipperLoader";
// import CommonSelect from "../../core/common/commonSelect";
type PasswordField =
  | "oldPassword"
  | "newPassword"
  | "confirmPassword"
  | "currentPassword";

const Profile = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    status: "",
  });

  const getUserProfileAPI = useApi<any>(getProfile, {
    method: "GET",
    autoCall: false,
    handleGlobalError: false,
  });

  useEffect(() => {
    const getUserProfile = async () => {
      try {
        const response = await getUserProfileAPI.callApi();

        if (response?.success) {
          setFormData({
            full_name: response.data.full_name || "",
            email: response.data.email || "",
            phone: response.data.phone || "",
            status: response.data.status || "",
          });
        }
      } catch (error) {
        console.error(error);
      }
    };

    getUserProfile();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [passwordVisibility, setPasswordVisibility] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
    currentPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {getUserProfileAPI.loading ? (
            <SnipperLoader />
          ) : (
            <div className="card">
              <div className="card-body">
                <div className="border-bottom mb-3 pb-3">
                  <h4>Profile </h4>
                </div>
                <form action="profile.html">
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div>
                          <h6 className="mb-3">Basic Information</h6>
                          {/* <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                            <i className="ti ti-photo text-gray-3 fs-16" />
                          </div>
                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Profile Photo</h6>
                              <p className="fs-12">
                                Recommended image size is 40px x 40px
                              </p>
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                Upload
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  multiple
                                />
                              </div>
                              <Link to="#" className="btn btn-light btn-sm">
                                Cancel
                              </Link>
                            </div>
                          </div>
                        </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">
                              Full Name
                            </label>
                          </div>
                          <div className="col-md-8">
                            <input
                              type="text"
                              name="full_name"
                              className="form-control"
                              // value={formData.full_name}
                              value={formData.full_name}
                              onChange={handleChange}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">Email</label>
                          </div>
                          <div className="col-md-8">
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              value={formData.email}
                              onChange={handleChange}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">Phone</label>
                          </div>
                          <div className="col-md-8">
                            <input
                              type="text"
                              name="phone"
                              className="form-control"
                              value={formData.phone}
                              onChange={handleChange}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">Status</label>
                          </div>
                          <div className="col-md-8">
                            <input
                              type="text"
                              className="form-control"
                              value={formData.status}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="mb-3">
                    <h6 className="mb-3">Address Information</h6>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-2">
                            <label className="form-label mb-md-0">
                              Address
                            </label>
                          </div>
                          <div className="col-md-10">
                            <input type="text" className="form-control" />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">
                              Country
                            </label>
                          </div>
                          <div className="col-md-8">

                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Country"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">State</label>
                          </div>
                          <div className="col-md-8">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter State"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">City</label>
                          </div>
                          <div className="col-md-8">
                           
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter City"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row align-items-center mb-3">
                          <div className="col-md-4">
                            <label className="form-label mb-md-0">
                              Postal Code
                            </label>
                          </div>
                          <div className="col-md-8">
                            <input type="number" className="form-control" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="border-bottom mb-3">
                  <h6 className="mb-3">Change Password</h6>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-5">
                          <label className="form-label mb-md-0">
                            Current Password
                          </label>
                        </div>
                        <div className="col-md-7">
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.currentPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                            />
                            <span
                              className={`ti toggle-passwords ${
                                passwordVisibility.currentPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                              }`}
                              onClick={() =>
                                togglePasswordVisibility("currentPassword")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-5">
                          <label className="form-label mb-md-0">
                            New Password
                          </label>
                        </div>
                        <div className="col-md-7">
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.newPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                            />
                            <span
                              className={`ti toggle-passwords ${
                                passwordVisibility.newPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                              }`}
                              onClick={() =>
                                togglePasswordVisibility("newPassword")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row align-items-center mb-3">
                        <div className="col-md-5">
                          <label className="form-label mb-md-0">
                            Confirm Password
                          </label>
                        </div>
                        <div className="col-md-7">
                          <div className="pass-group">
                            <input
                              type={
                                passwordVisibility.confirmPassword
                                  ? "text"
                                  : "password"
                              }
                              className="pass-input form-control"
                            />
                            <span
                              className={`ti toggle-passwords ${
                                passwordVisibility.confirmPassword
                                  ? "ti-eye"
                                  : "ti-eye-off"
                              }`}
                              onClick={() =>
                                togglePasswordVisibility("confirmPassword")
                              }
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                  {/* <div className="d-flex align-items-center justify-content-end">
                  <button
                    type="button"
                    className="btn btn-outline-light border me-3"
                  >
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary l">
                    Save
                  </button>
                </div> */}
                </form>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default Profile;
